import { Observable } from 'rxjs';
import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { NavigationService, IFooterItem } from 'src/app/service/navigation.service';
import { FooterService, IFooterContactInfoItem } from 'src/app/service/footer.service';
import { ISiteFooterSettings } from 'src/app/shared/interface/site-settings';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
})
export class FooterComponent implements OnInit {
  @Input() settings: ISiteFooterSettings;
  @Input() data: IFooterContactInfoItem;
  footer: IFooterItem;
  info$: Observable<IFooterContactInfoItem> = this.footerService.getFooter();
  footerSubscription: any;

  constructor(
    private navigationService: NavigationService,
    private footerService: FooterService,
    private translateService: TranslateService,
    private host: ElementRef<HTMLElement>
  ) { }

  ngOnInit() {
    this.footerSubscription = {
      title: {value: this.translateService.instant('footer.Subscription.Title')},
      inputLabel: this.translateService.instant('footer.Subscription.InputLabel'),
      description: {value: ''},
      agreementText: {value: this.settings && this.settings.footerSubscription && this.settings.footerSubscription.agreement},
      cookiePolicyPageUrl: this.data && this.data.cookiePolicyPageUrl,
      reCaptchaSecret: this.data && this.data.reCaptchaSecret,
      cookiePolicyTitle: this.translateService.instant('footer.CookiePolicyLink.Title'),
    }
    this.navigationService.getFooterNavigation().subscribe((res) => {
      if (res) {
        this.footer = res;
      }
    });

    if (this.data) {
      this.setHostCustomStyles(this.data);
    }
  }

  setHostCustomStyles(data: IFooterContactInfoItem) {
    this.host.nativeElement.style.setProperty('--backgroundColor', data.backgroundColor);
    const body = window.document.getElementsByTagName('body')[0];
    if (data.buttonsColor) {
      body.style.setProperty('--footerButtonsColor', data.buttonsColor);
    } else {
      body.style.removeProperty('--footerButtonsColor');
    }
  }
}
